import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Input,
    DatePicker,
    Upload,
    Icon,
    message,
} from 'antd';
const FormItem = Form.Item;
const { RangePicker } = DatePicker;
import { actions, asyncGet, asyncUpload } from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { formatFormData } from './utils';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        this.props.changeSearchValues(formatFormData(values));
        this.props.resetPagination();
        this.props.asyncGet();
    }
    handleReset= () => {
        this.props.form.resetFields();
    }

    /**
     * 上传文件
     */
    handleUploadIcon = data => {
        let formData = new FormData();
        formData.append('file', data.file);
        this.props.asyncUpload(formData);
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { isFileLoading } = this.props;
        // const propsFile = {
        //     showUploadList: false,
        //     name: 'file',
        //     action: 'upload',
        //     customRequest: this.handleUploadIcon,
        // };
        const propsFile = {
            name: 'file',
            action: '//120.92.118.247/upload',
            headers: {
                Authorization: 'Basic aGlwcG86aGlwcG8=',
            },
            showUploadList: false,
            beforeUpload: () => {
                this.props.changeUiStatus({isFileLoading: true});
                return true;
            },
            onChange: info => {
                if (info.file.status !== 'uploading') {
                    this.props.changeUiStatus({isFileLoading: false});
                }
                if (info.file.status === 'done') {
                    message.success(`${info.file.name} 文件上传成功`);
                    this.props.asyncGet();
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} 文件上传失败.`);
                }
            },
        };
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>文件管理</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem {...spans} label="文件名">
                                {getFieldDecorator('fileName')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...spans} label="时间段">
                                {getFieldDecorator('dateTime')(
                                    <RangePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        placeholder="选择时间"
                                    />)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                            <Upload {...propsFile}>
                                <Button type="default" loading={isFileLoading}>
                                    <Icon type="upload" /> 上传
                                </Button>
                            </Upload>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isFileLoading: state.fileList.uiStatus.isFileLoading,
});

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    asyncUpload: data => dispatch(asyncUpload(data)),
    changeUiStatus: data => dispatch(actions.changeUiStatus(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));




// WEBPACK FOOTER //
// ./pages/fileList/search.js